import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import TrackedPrompt from '../../prompts/TrackedPrompt';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { getFormattedContactName } from '../../contacts/operators/contactGetters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function DisassociateModal({
  contact,
  onReject,
  onConfirm
}) {
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "danger",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onReject
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.crm-integration.disassociatePrompt.title",
          options: {
            name: getFormattedContactName(contact)
          }
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {}), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "danger",
        onClick: onConfirm,
        "data-test-id": "disassociate-modal-confirm",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.crm-integration.disassociatePrompt.save"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        onClick: onReject,
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-ui.crm-integration.disassociatePrompt.cancel"
        })
      })]
    })]
  });
}
DisassociateModal.displayName = 'DisassociateModal';
export default TrackedPrompt({
  promptName: 'disassociate-contact-prompt'
})(DisassociateModal);